import { defineComponent as _defineComponent } from 'vue'
import Icon from '@components/Icon.vue';

import { faHome } from '@icons/regular/faHome';
import { faDroneFront } from '@icons/duotone/faDroneFront';
import { faQuestion } from '@icons/solid/faQuestion';

export default /*#__PURE__*/_defineComponent({
  __name: 'Error404View',
  setup(__props) {


return { __sfc: true,Icon, faHome, faDroneFront, faQuestion }
}

})